module.exports = __webpack_public_path__ + "img/pr-3.f15c0e84.png";